import { useEffect, useState } from 'react';
import { Table, SORT_DIRECTION, SortModel } from '@qrios/frontend-library';

import { columns } from './columns';
import { mapLogValue } from './helpers';
import { PresentEventsType } from './interfaces';

interface Props {
  events: PresentEventsType;
}
const PresentEvents = ({ events }: Props) => {
  const [sortModel, setSortModel] = useState<SortModel>([{ field: 'date', sort: SORT_DIRECTION.ASC }]);

  const rows = events.items.map((event, index) => ({
    date: event.date,
    id: index,
    type: event.type,
    log: mapLogValue(event)
  }));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    /**
     * Looks like we cannot declare Table loading property as false,
     * because it's a problem with horizontal scroll visibility.
     * When the vertical scroll is visible, the horizontal scroll is also visible, what is wrong behavior.
     * It fixes this issue, looks like it's something related to the material-ui grid
     */
    setTimeout(() => {
      setLoading(false);
    }, 0);
  }, []);

  return (
    <Table
      dataGridProps={{
        rows,
        loading,
        sortModel,
        columns,
        emptyMsg: 'There are no audit logs for this USSD session',
        onSortModelChange: model => setSortModel(model)
      }}
      headProps={{
        title: 'USSD session audit logs'
      }}
    />
  );
};

export default PresentEvents;
